import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import PageLayout from '@components/layout/PageLayout';
import Tabs, { TabItem } from '@components/common/Tabs';
import ErrorBoundary from '@components/common/ErrorBoundary';
import { NotificationSettingsTab, NotificationHistoryTab } from '@components/features/notification-settings';
import { EmailTemplatesTab } from '@components/features/email-templates';
import styles from './NotificationSettingsPage.module.css';

const tabs: TabItem[] = [
  { key: 'settings', label: 'Settings' },
  { key: 'history', label: 'History' },
  { key: 'email-templates', label: 'Email Templates' }
];

const NotificationSettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('settings');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'history':
        return (
          <ErrorBoundary level="page">
            {/* Gate the history queries so they fire only while this tab is active. */}
            <NotificationHistoryTab enabled={activeTab === 'history'} />
          </ErrorBoundary>
        );
      case 'email-templates':
        return (
          <ErrorBoundary level="page">
            <EmailTemplatesTab />
          </ErrorBoundary>
        );
      case 'settings':
      default:
        return (
          <ErrorBoundary level="page">
            <NotificationSettingsTab />
          </ErrorBoundary>
        );
    }
  };

  return (
    <PageLayout>
      <div className={styles.notificationSettingsPage} data-test-id="notification-settings-page">
        <header className={styles.pageHeader}>
          <div className={styles.headerContent}>
            <Bell size={24} />
            <h1>Notifications</h1>
          </div>
          <p className={styles.headerSubtitle}>
            Configure when notifications are sent, who receives them, and the global delivery window, and review the
            delivery history. Changes are audited and apply on the next run.
          </p>
        </header>

        <Tabs items={tabs} activeTab={activeTab} onTabChange={setActiveTab} className={styles.tabs} />

        <div className={styles.tabContent}>{renderTabContent()}</div>
      </div>
    </PageLayout>
  );
};

export default NotificationSettingsPage;
